module.exports = __webpack_public_path__ + "static/img/logo.8e33ece7.png";